import React from 'react';
function About() {
return (
<section className="section" id="about">
<div className="container grid-two">
<div>
<p className="section-subtitle">About Us</p>
<h2 className="section-title">We Turn Ideas Into Scalable Software
Products</h2>
</div>
<div>
<p className="section-text">
ZuelonX IT Solution delivers modern digital solutions for businesses worldwide.
We specialize in web development, mobile application development, software solutions, 
cloud services, digital marketing, SEO optimization, branding, and IT support.
Our mission is to help businesses grow through innovative technology, 
strong online presence, secure systems, and professional digital experiences. 
ZuelonX focuses on quality, creativity, reliability,and customer satisfaction 
to provide smart and scalable solutions for startups, small businesses, and enterprises.
</p>

</div>
</div>
</section>
);
}
export default About;